module.exports = __webpack_public_path__ + "img/qidian.8c66c9b9.png";